export const initMobileMenuState = () => {
  const navCollapse = document.querySelector('#mainNav');
  const desktopQuery = window.matchMedia('(min-width: 992px)');
  const navTrigger = document.querySelector('[data-bs-target="#mainNav"], [href="#mainNav"]');

  if (!navCollapse) {
    return;
  }

  const closeNavCollapse = () => {
    const collapseApi = window.bootstrap?.Collapse;

    if (collapseApi) {
      const collapseInstance = collapseApi.getOrCreateInstance(navCollapse);
      collapseInstance.hide();
      return;
    }

    // Fallback for environments where Bootstrap API is not exposed on window.
    if (navTrigger instanceof HTMLElement) {
      navTrigger.click();
      return;
    }

    navCollapse.classList.remove('show');
    document.body.classList.remove('menu-open');
  };

  navCollapse.addEventListener('show.bs.collapse', () => {
    document.body.classList.add('menu-open');
  });

  navCollapse.addEventListener('hidden.bs.collapse', () => {
    document.body.classList.remove('menu-open');
  });

  document.addEventListener('click', (event) => {
    if (!navCollapse.classList.contains('show')) {
      return;
    }

    const clickedNode = event.target;

    if (!(clickedNode instanceof Node) || navCollapse.contains(clickedNode)) {
      return;
    }

    closeNavCollapse();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !document.body.classList.contains('menu-open')) {
      return;
    }

    closeNavCollapse();
  });

  const syncMenuStateOnResize = () => {
    if (!desktopQuery.matches) {
      return;
    }

    document.body.classList.remove('menu-open');
  };

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', syncMenuStateOnResize);
  } else {
    desktopQuery.addListener(syncMenuStateOnResize);
  }
};